const DOC_PREFIX = 'DOC-'

export function toPolicyDisplayId(policyUuid: string): string | null {
  const compact = String(policyUuid || '').replace(/-/g, '').toUpperCase()
  if (compact.length < 6) return null
  return `${DOC_PREFIX}${compact.slice(0, 6)}`
}

export function copyToClipboard(text: string): Promise<void> {
  return navigator.clipboard.writeText(text)
}
